/**
 * Created by jv on 31/03/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const Error = require("Sources/models/error");
const Order = require("Sources/models/order");
const Subscription = require("Sources/models/subscription");
const Customer = require("Sources/models/admin/customer");
const SubscriptionHistory = require("Sources/models/admin/subscription-history");
const GroupPurchase = require("Sources/models/admin/group-purchase");

var adminServices = {};

(function(AdminServices)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  AdminServices.getOrders = function(filters, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_orders"),
      cache: false,
      dataType: "json",
      contentType: "application/json",
      data: {
        keyword: filters.keyword,
        status: filters.status,
        orderTypes: filters.orderTypes,
        offset: filters.offset,
        limit: filters.limit,
        fromDate: filters.fromDate,
        tillDate: filters.tillDate
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var orders = [];
        var rowCount;

        if(data.result.result.hasOwnProperty("orders"))
        {
          for(var i = 0; i < data.result.result.orders.length; i++)
          {
            orders.push(new Order(data.result.result.orders[i]));
          }
        }

        if(data.result.result.hasOwnProperty("row-count"))
        {
          rowCount = data.result.result["row-count"];
        }

        successCb(orders, rowCount);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getSubscriptions = function(filters, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_subscriptions"),
      cache: false,
      dataType: "json",
      contentType: "application/json",
      data: {
        keyword: filters.keyword,
        status: filters.status,
        paymentStatus: filters.paymentStatus,
        subscriptionTypes: filters.subscriptionTypes,
        offset: filters.offset,
        limit: filters.limit
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var subscriptions = [];
        var rowCount;

        if(data.result.result.hasOwnProperty("summaries"))
        {
          for(var i = 0; i < data.result.result.summaries.length; i++)
          {
            subscriptions.push(new Subscription(data.result.result.summaries[i]));
          }
        }

        if(data.result.result.hasOwnProperty("row-count"))
        {
          rowCount = data.result.result["row-count"];
        }

        successCb(subscriptions, rowCount);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrderContact = function(contactObj, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("update_order_contact"),
      cache: false,
      dataType: "json",
      data: {
        "order-number": contactObj.orderNumber,
        "type": contactObj.type,
        "firstname": contactObj.firstname,
        "lastname": contactObj.lastname,
        "email": contactObj.email,
        "phone": contactObj.phone,
        "mobile": contactObj.mobile,
        "organisation": contactObj.organisation,
        "address1": contactObj.address1,
        "address2": contactObj.address2,
        "zip": contactObj.zip,
        "city": contactObj.city,
        "country": contactObj.country,
        "identification": contactObj.identification,
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Order(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrder = function(orderObj, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url: utils.getServiceUrl("admin_update_order"),
      cache: false,
      dataType: "json",
      data: {
        "number": orderObj.number,
        "profile-key": orderObj.profileKey,
        "customer-key": orderObj.customerKey,
        "type": orderObj.type,
        "bestelbon-required": orderObj.purchaseOrderRequired,
        "bestelbon-number": orderObj.purchaseOrderNumber,
        "vat": orderObj.vat,
        "company-number": orderObj.companyNumber,
        "remark": orderObj.remark,
        "on-hold": orderObj.onHold,
        "comment": orderObj.comment
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getCustomers = function(keyword, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_customers"),
      cache: false,
      dataType: "json",
      data: {
        keyword: keyword
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var customers = [];

        if(data.result.result.hasOwnProperty("customer-list"))
        {
          for(var i = 0; i < data.result.result["customer-list"].length; i++)
          {
            customers.push(new Customer(data.result.result["customer-list"][i]));
          }
        }

        successCb(customers);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getCustomerDetails = function(customerKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_get_customer"),
      cache: false,
      dataType: "json",
      data: {
        "key": customerKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Customer(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateCustomer = function(customerObj, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_customer"),
      cache: false,
      dataType: "json",
      data: {
        "key": customerObj.key,
        "type": customerObj.type,
        "country": customerObj.country,
        "identification": customerObj.identification,
        "description": customerObj.description
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrderStatus = function(orderNumber, status, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_order_status"),
      cache: false,
      dataType: "json",
      data: {
        "number": orderNumber,
        "status": status
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrderOnHold = function(orderNumber, onHold, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_order_on_hold"),
      cache: false,
      dataType: "json",
      data: {
        "number": orderNumber,
        "on-hold": onHold
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrderComment = function(orderNumber, comment, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_order_comment"),
      cache: false,
      dataType: "json",
      data: {
        "number": orderNumber,
        "comment": comment
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getSubscriptionsForCustomer = function(customerKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_subscriptions_for_customer"),
      cache: false,
      dataType: "json",
      data: {
        "customer-key": customerKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var subscriptions = [];

        if(data.result.result.hasOwnProperty("summaries"))
        {
          for(var i = 0; i < data.result.result.summaries.length; i++)
          {
            subscriptions.push(new Subscription(data.result.result.summaries[i]));
          }
        }

        successCb(subscriptions);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getOrdersForCustomer = function(customerKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_orders_for_customer"),
      cache: false,
      dataType: "json",
      data: {
        "customer-key": customerKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var orders = [];

        if(data.result.result.hasOwnProperty("orders"))
        {
          for(var i = 0; i < data.result.result.orders.length; i++)
          {
            orders.push(new Order(data.result.result.orders[i]));
          }
        }

        successCb(orders);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateOrderDelivery = function(dataObj, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_order_delivery"),
      cache: false,
      dataType: "json",
      data: {
        "number": dataObj.number,
        "article-codes": dataObj.articleCodes,
        "delivery-date": dataObj.deliveryDate
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getHistoryForSubscription = function(subscriptionKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_list_subscription_history"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var history = [];

        if(data.result.result.hasOwnProperty("subscription-history-list"))
        {
          for(var i = 0; i < data.result.result["subscription-history-list"].length; i++)
          {
            history.push(new SubscriptionHistory(data.result.result["subscription-history-list"][i]));
          }
        }

        successCb(history);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateSubscriptionGrace = function(subscriptionKey, grace, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_subscription_grace"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        grace: grace
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.updateSubscriptionCorrection = function(subscriptionKey, correction, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("admin_update_subscription_correction"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        correction: correction
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  AdminServices.getGroupPurchases = function(successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("admin_list_group_purchases"),
        cache: false,
        dataType: "json",
        data: {

        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var groupPurchases = [];

          if(data.result.result.hasOwnProperty("group-purchase-list"))
          {
            for(var i = 0; i < data.result.result["group-purchase-list"].length; i++)
            {
              groupPurchases.push(new GroupPurchase(data.result.result["group-purchase-list"][i]));
            }
          }

          successCb(groupPurchases);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  AdminServices.getGroupPurchase = function(groupPurchaseKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("admin_get_group_purchase"),
        cache: false,
        dataType: "json",
        data: {
          "group-purchase-key": groupPurchaseKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          successCb(new GroupPurchase(data.result.result));
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  AdminServices.getSubscriptionsForGroupPurchase = function(groupPurchaseKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("admin_list_subscriptions_for_group_purchase"),
        cache: false,
        dataType: "json",
        data: {
          "group-purchase-key": groupPurchaseKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var subscriptions = [];

          if(data.result.result.hasOwnProperty("summaries"))
          {
            for(var i = 0; i < data.result.result.summaries.length; i++)
            {
              subscriptions.push(new Subscription(data.result.result.summaries[i]));
            }
          }

          successCb(subscriptions);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  AdminServices.getOrdersForGroupPurchase = function(groupPurchaseKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("admin_list_orders_for_group_purchase"),
        cache: false,
        dataType: "json",
        data: {
          "group-purchase-key": groupPurchaseKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var orders = [];

          if(data.result.result.hasOwnProperty("orders"))
          {
            for(var i = 0; i < data.result.result.orders.length; i++)
            {
              orders.push(new Order(data.result.result.orders[i]));
            }
          }

          successCb(orders);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

}(adminServices));

module.exports = adminServices;



// WEBPACK FOOTER //
// ./app/js/services/fundels/admin-services.js